import AppHeader from '@/components/Elements/Header/AppHeader';
import { ReservationUrls } from '@/features/reservation/constants/urls';
import { LinearProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAuthentification } from '@/hooks/useAuth';
import { Backdrop, Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router';

export const NotFound = () => {
  const navigate = useNavigate();
  const { isAuth, isLoading } = useAuthentification();

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        const newProgress = oldProgress + 500 / 30;
        return Math.min(newProgress, 100);
      });
    }, 500);
    const timeout = setTimeout(() => {
      clearInterval(interval);
      isAuth
        ? navigate(ReservationUrls.Reservation, { replace: true })
        : navigate(ReservationUrls.Root, { replace: true });
    }, 3500);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <>
      <Backdrop open={isLoading} />
      <AppHeader title={'エラー'} />
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} justifyContent={'center'} spacing={2} sx={{ mt: 4 }}>
          <Grid item sx={{ mt: 2 }} textAlign={'center'} className="font-bold" xs={12}>
            ページが見つかりません
          </Grid>
          <Grid item sx={{ mt: 2 }} textAlign={'center'} className="" xs={12}>
            指定されたページが存在しないか、アクセスが許可されていません。<br></br>
            3秒後に自動的に
            <span className="font-bold text-primary">
              <button onClick={() => navigate(ReservationUrls.Reservation, { replace: true })}>トップページ</button>
            </span>
            へリダイレクトされます。
          </Grid>
          <Grid xs={10} sx={{ mt: '2' }}>
            <LinearProgress variant="determinate" value={progress} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
